// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"9147a256","239":"0e5c5d01","453":"1e06516e","633":"6ebf3eb1","732":"c4f88969","977":"4c01f7e2"}[chunkId] + ".chunk.js";
};